var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPost56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 7.79086 5.79086 6 8 6H48C50.2091 6 52 7.79086 52 10V46C52 48.2091 50.2091 50 48 50H8C5.79086 50 4 48.2091 4 46V10Z",
    fill: "#309FF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 10.8954 8.89543 10 10 10H14C15.1046 10 16 10.8954 16 12V16C16 17.1046 15.1046 18 14 18H10C8.89543 18 8 17.1046 8 16V12Z",
    fill: "#F5F5FF",
    fillOpacity: 0.68
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H52V44H4V22Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14C20 12.8954 20.8954 12 22 12H35C36.1046 12 37 12.8954 37 14C37 15.1046 36.1046 16 35 16H22C20.8954 16 20 15.1046 20 14Z",
    fill: "#F5F5FF",
    fillOpacity: 0.68
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost56);
export default __webpack_public_path__ + "static/media/post_56.32a43e33.svg";
export { ForwardRef as ReactComponent };